import React, { useState, useEffect } from "react";
import {
  Card, CardContent, Typography, Box, Button, TextField, MenuItem, Select,
  FormControl, Grid, InputLabel, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper
} from "@mui/material";
import axios from "axios";
import config from "../config";

const ReservationReport = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [roomName, setRoomName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reservations, setReservations] = useState([]);
  const [roomNames, setRoomNames] = useState([]);

  const handleLocationChange = (e) => {
    setSelectedLocation(e.target.value);
    setRoomName("");
    setRoomNames([]);
  };

  const handleSubmit = async () => {
    if (!selectedLocation || !fromDate || !toDate) {
      setError("Please fill all fields.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.get(`${config.API_BASE_URL}/report/getRoomData`, {
        params: { location: selectedLocation, fromDate, toDate },
      });

      const data = response.data;
      setReservations(data);

      // console.log("BRRRRRRRRRRRRRRRRR", data)

      // extract unique room names
      const uniqueRoomNames = [...new Set(data.map((item) => item.roomName))];
      setRoomNames(uniqueRoomNames);

    } catch (err) {
      console.error("Error fetching data:", err);
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Something went wrong.");
      }
      setReservations([]);
      setRoomNames([]);
    }

    setLoading(false);
  };

  const filteredReservations = roomName
    ? reservations.filter((res) => res.roomName === roomName)
    : reservations;

  return (
    <Box sx={{ flexGrow: 1, padding: "10px", paddingLeft: "260px", paddingTop: "60px" }}>
      <Card sx={{ width: "100%", padding: "15px", borderRadius: "10px", borderTop: "4px solid blue" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Reserved BoardRooms Report
          </Typography>
          <hr />
          {error && <Typography color="error">{error}</Typography>}

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <FormControl fullWidth disabled={loading}>
                <InputLabel>Select Location</InputLabel>
                <Select value={selectedLocation} onChange={handleLocationChange}>
                  <MenuItem value="Factory">Factory</MenuItem>
                  <MenuItem value="HeadOffice">Head Office</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                type="date"
                label="From Date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                type="date"
                label="To Date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                fullWidth
                disabled={loading}
              >
                {loading ? "Loading..." : "Get Reservations Detail"}
              </Button>
            </Grid>
          </Grid>

          {/* Room Filter Dropdown */}
          {roomNames.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Filter by Room Name</InputLabel>
                <Select
                  value={roomName}
                  onChange={(e) => setRoomName(e.target.value)}
                  label="Filter by Room Name"
                >
                  <MenuItem value="">All Rooms</MenuItem>
                  {roomNames.map((name, index) => (
                    <MenuItem key={index} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

          {/* Reservation Table */}
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead sx={{ background: "#0c2a73" }}>
                <TableRow>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>S.No.</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Location</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Room Name</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Reserved By</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Start Date</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>End Date</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Emp Code</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>No. of Persons</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Purpose</TableCell>
                  <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Status</TableCell>
                  {/* <TableCell  sx={{ color:"white", fontWeight: "bold", fontSize: "16px" }}>Timestamp</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredReservations.map((reservation, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{reservation.selectedLocation}</TableCell>
                    <TableCell>{reservation.roomName}</TableCell>
                    <TableCell>{reservation.reserveBy}</TableCell>
                    <TableCell>{new Date(reservation.selectedStartDate).toLocaleString()}</TableCell>
                    <TableCell>{new Date(reservation.selectedEndDate).toLocaleString()}</TableCell>
                    <TableCell>{reservation.EmpCode}</TableCell>
                    <TableCell>{reservation.noOfPersons}</TableCell>
                    <TableCell>{reservation.purposeOfMeeting}</TableCell>
                    <TableCell>{reservation.status}</TableCell>
                    {/* <TableCell>{reservation.timestamp ? new Date(reservation.timestamp).toLocaleString() : "N/A"}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReservationReport;
